import React from 'react';
import { noop } from 'lodash';
import PropTypes from 'prop-types';
import { Draggable } from 'react-beautiful-dnd';
import Checkbox from '../common/checkbox/Checkbox';
import checkBoxStyle from './CheckboxOverride.module.scss';
import DragAndDropIconInactive from '../common/Icons/Drag.svg';
import DragAndDropIconActive from '../common/Icons/Drag-Active.svg';
import Symbol from '../common/symbols/Symbol';

const rowSelected = (value) => {
    if (value.visible) {
        return 'columnDropdownRowChecked';
    }
    return 'columnDropdownRowUnchecked';
};

const DropdownRows = (props) => (
    <div>
        { props.columns.filter((column) => !column.draggable).map(
            (item) => (
                <div
                    className={ props.styles[rowSelected(item)] }
                    key={ item.id }
                >
                    <div
                        className={ props.styles.checkboxRow }
                    >
                        <Checkbox
                            disabled={ !item.hideable }
                            styles={ checkBoxStyle }
                            checked={ item.visible }
                            onChange={ (checked) => {
                                props.setColumnVisibility(item, checked);
                            } }
                        />
                    </div>
                    <div
                        className={ props.styles.title }
                    >
                        <Symbol symbol={ item.symbol }>{ item.title }</Symbol>
                    </div>
                    <div />
                </div>
            )
        ) }

        { props.columns.filter((column) => column.draggable).map(
            (item, index) => (
                <Draggable
                    key={ item.id }
                    draggableId={ item.id }
                    index={ index }
                >
                    { (provided, snapshot) => (
                        <div
                            className={ props.styles[rowSelected(item)] }
                            ref={ provided.innerRef }
                            { ...provided.draggableProps }
                            { ...provided.dragHandleProps }
                        >
                            <div
                                className={ props.styles.checkboxRow }
                            >
                                <Checkbox
                                    disabled={ !item.hideable }
                                    styles={ checkBoxStyle }
                                    checked={ item.visible }
                                    onChange={ (checked) => {
                                        props.setColumnVisibility(item, checked);
                                    } }
                                />
                            </div>
                            <div
                                className={ props.styles.title }
                            >
                                <Symbol symbol={ item.symbol }>{ item.title }</Symbol>
                            </div>
                            <div>
                                <button
                                    className={ props.styles.columnButton }
                                    type="button"
                                >
                                    <img
                                        src={ snapshot.isDragging
                                            ? DragAndDropIconActive : DragAndDropIconInactive }
                                        alt=""
                                        className={ props.styles.svg }
                                    />
                                </button>
                            </div>
                        </div>
                    ) }
                </Draggable>
            )
        ) }
    </div>
);

DropdownRows.propTypes = {
    setColumnVisibility: PropTypes.func,
    columns: PropTypes.arrayOf(
        PropTypes.shape({
            title: PropTypes.string,
            id: PropTypes.string,
            type: PropTypes.string
        })
    ),
    styles: PropTypes.objectOf(PropTypes.string).isRequired
};

DropdownRows.defaultProps = {
    columns: [],
    setColumnVisibility: noop,
};

export default DropdownRows;
